// extracted by mini-css-extract-plugin
export default {"homeContainer":"HomePage_homeContainer__HjLED","homeImage":"HomePage_homeImage__gshmX"};